var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFees = function SvgFees(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.164 17.5H4.997a3.333 3.333 0 0 1-3.333-3.333V2.5h12.5zm4.167-2.5a2.5 2.5 0 0 1-2.5 2.5V9.167h2.5zM7.081 6.667a2.083 2.083 0 0 0 0 4.166h1.666a.418.418 0 0 1 0 .834H5.83v1.666h1.25v.834h1.667v-.834a2.083 2.083 0 0 0 0-4.166H7.08a.417.417 0 0 1 0-.834h2.917V6.667h-1.25v-.834H7.08z"
  })));
};
export default SvgFees;